import { Component, inject, OnInit } from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';

import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { TranslationSetupService } from './core/services/translation-setup.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, ButtonModule, ToastModule],
  template: ` <router-outlet></router-outlet>
    <!-- * Message -->
    <p-toast position="bottom-right" key="br"></p-toast>

    <!-- * Warn message -->
    <p-toast position="bottom-right" key="br-warn"></p-toast>

    <!-- * Error message -->
    <p-toast position="bottom-right" key="br-error"></p-toast>`,
})
export class AppComponent implements OnInit {
  contexts = inject(ChildrenOutletContexts);
  translationSetup = inject(TranslationSetupService);
  ngOnInit() {
    this.translationSetup.setupTranslation();
  }
}
